import styled from 'styled-components';

export const FormCheckbox = styled.label`
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  
  input {
    opacity: 0;
    margin-right: 12px;
    width: auto !important;
    flex-shrink: 0;
    margin-top: 2px;
    position: relative;
    z-index: 1;

    &:checked ~ .checkmark {
      border-color: #F6B615;
      
      &:after {
        content: '';
        position: absolute;
        left: 5px;
        top: 1px;
        width: 6px;
        height: 12px;
        border: solid #F6B615;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }
  
  .checkmark {
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid #C4D2D9;
    flex-shrink: 0;
  }
`;

export const FormCheckboxText = styled.span`
  font-weight: 500;
  line-height: 16px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.lightGray};
  display: inline-block;
  flex: 1;
  margin-top: 0;
`;

export const FormCheckboxLink = styled.a`
  color: ${({ theme }) => theme.colors.link};
  border-bottom: 1px dashed ${({ theme }) => theme.colors.link};
  text-decoration: none;
  
  &:hover {
    text-decoration: none;
  }
`;
